import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "primeflex/primeflex.css";

import "./assets/fonts/satoshi/fonts.css";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { MotionPlugin } from '@vueuse/motion'


// -------------------------------------------
// 🔥 GOOGLE ANALYTICS + PAGEVIEW EN VUE SPA
// -------------------------------------------

// Cuando Google Tag ya está cargado en index.html, esta función se podrá ejecutar
router.afterEach((to) => {
  if (window.gtag) {
    window.gtag("config", "G-766P6C7J28", {
      page_path: to.fullPath,
    });
  }
});

// -------------------------------------------
createApp(App)
  .use(router)
  
  .use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    loaderOptions: {
      autoHideBadge: false, // opcional
      useRecaptchaNet: true, // opcional: a veces evita bloqueos
      explicitRenderParameters: { badge: "bottomright" }, // posición controlada
      defer: true, // ⚡ carga el script de forma diferida
      async: true, // ⚡ no bloquea el render inicial
    },
  })
  .use(MotionPlugin)
  .mount("#app");
